import { useRef } from 'react';

export function useRefs<T extends Record<string, any>>(values: T) {
  const refs = useRef<T>(values);
  refs.current = values;
  return refs;
}
